import { IProduct } from './products/product';
import { Renewal } from './products/renewal';
import { UserService }  from './../../../shared/services/user.service';
  
export interface IPurchase {
  products: IProduct[];
  taxRate: number;
  paymentDate: Date;
  activeMember: boolean;

  subtotal: number;
  taxAmount: number;
  total: number;
  getEffectiveProductPrice(product): number;
  getBaseProductPrice(product): number;
  practitionerName: string;
  paymentMethod: string;
  itemCount: number;
}

export class Purchase implements IPurchase {
  products = [];
  paymentDate = null;
  
  practitionerName;
  paymentMethod;
  
  get activeMember(){
    return this.userService.CurrentUser.status !== 'I';
  }
  constructor(private userService: UserService){    
  }

  get itemCount(){
    let count = 0;
    this.products.forEach(p => {
      count += p.quantity;
    });
    return count;
  }

  get taxRate() { return .091; }

  get subtotal() {
    let amount = 0;

    this.products.forEach((p) => {      
      amount += this.getEffectiveProductPrice(p) * p.quantity; 
    });

    return amount;
  }

  get taxAmount() { return Math.round(this.taxableAmount * this.taxRate * 100 ) / 100; }

  get total(): number {
    return this.subtotal + this.taxAmount;
  }

  private get taxableAmount(): number {
    let amount = 0;

    this.products
      .filter((p:IProduct) => p.taxable)
      .forEach((p) => {       
        amount += this.getEffectiveProductPrice(p) * p.quantity;        
      });

    return amount;
  }

  getEffectiveProductPrice(product):number{            
    let price = 0;
    const isProductRenewal = this.products.find(p => p.constructor === Renewal);        
    if(product.price) {return product.price;}
    if(this.activeMember || isProductRenewal){                 
      price = product.activePrice ? product.activePrice : product.activeRate;
    }
    else {            
      price = product.inactivePrice ? product.inactivePrice : product.inactiveRate;      
    }
    if(!price)
      {return 0;}
    else 
      {return price;}
  }

  getBaseProductPrice(product):number{        
    const isProductRenewal = this.products.find(p => p.constructor === Renewal);        
    if(this.activeMember || isProductRenewal){     
      if (!product.inactivePrice) 
        {return 0;}
      else             
        {return product.inactivePrice;}
    }            
    return 0;
  }
}
